import { Link } from "@wix/wix-ui-icons-common";
import React from "react";
import { Link_Target } from "./../../ricos-schema/legacy/wix/rich_content/v1/index.js";
import { LinkButton } from "./../../toolbars-v3/index.js";
import { PLUGIN_TOOLBAR_LINK_BUTTON } from "../data-hooks.js";
import { toggleLinkModal } from "../link-modal/toggle-link-modal.js";
import { getNodeInSelection } from "../resolvers/get-node-in-selection.js";
import { getNodeLinkData } from "../resolvers/get-node-link-data.js";
import { isLinkOrAnchorInSelection } from "../resolvers/is-link-or-anchor-in-selection.js";
import { PLUGIN_TOOLBAR_BUTTON_ID } from "./plugin-toolbar-buttons-ids.js";
const createLinkButton = (services) => {
  return {
    id: PLUGIN_TOOLBAR_BUTTON_ID.LINK,
    type: "modal",
    attributes: {
      active: isLinkOrAnchorInSelection,
      linkData: getNodeLinkData,
      selectedNode: getNodeInSelection
    },
    renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(LinkButton, { toolbarItem }),
    dataHook: PLUGIN_TOOLBAR_LINK_BUTTON,
    tooltip: "ButtonModal_Button_Link",
    icon: Link,
    command: ({ modals, referenceElement, tiptapEditor, attributes }) => {
      const onSave = (link) => {
        const attrs = attributes.selectedNode.attrs;
        tiptapEditor.chain().focus().setNodeAttrsById(attrs.id, { ...attrs, link }).run();
        services.pluginsEvents.publishPluginLinkable({
          pluginId: attributes.selectedNode.type.name,
          nodeId: attributes.selectedNode.attrs.id,
          link: link.url,
          newTab: link.target === Link_Target.BLANK,
          nofollow: link.rel?.nofollow
        });
      };
      const onUnlink = () => {
        const { link, ...attrs } = attributes.selectedNode?.attrs ?? {};
        tiptapEditor.chain().focus().setNodeAttrsById(attrs.id, attrs).run();
      };
      return toggleLinkModal({
        initialValue: attributes.linkData,
        modalService: modals,
        onSave,
        onUnlink,
        referenceElement
      });
    }
  };
};
export {
  createLinkButton
};
//# sourceMappingURL=create-link-button.js.map
